var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      staticClass: "upload-demo",
      attrs: {
        action: _vm.uploadFileUrl,
        "on-success": _vm.uploadSuccess,
        "on-error": _vm.uploadError,
        "before-upload": _vm.beforeUpload,
        accept: _vm.accept,
        "on-format-error": _vm.handleFormatError,
        multiple: "",
      },
    },
    [
      _c("el-button", { attrs: { size: "small", type: "primary" } }, [
        _vm._v("点击上传"),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }